// @ts-check
/**@const {Object <String, String>} */
const keyCodes = {
    'ARROW_DOWN': 'ArrowDown',
    'ARROW_LEFT': 'ArrowLeft',
    'ARROW_RIGHT': 'ArrowRight',
    'ARROW_UP': 'ArrowUp',
    'DOWN': 'Down',
    'END': 'End',
    'ENTER': 'Enter',
    'ESC': 'Esc',
    'ESCAPE': 'Escape',
    'HOME': 'Home',
    'LEFT': 'Left',
    'RIGHT': 'Right',
    'SPACE': ' ',
    'SPACEBAR': 'Spacebar',
    'TAB': 'Tab',
    'UP': 'Up'
};
/**
 * A class to present a keycodes API. This should be somewhat immutable
 * due to the exposed class only using getters that use the "as private as you can get
 * in javascript for now" keyCodes array.
 * See {@link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values|Key Values}.
 */
export default class KeyCodes {
    /**
     * Gets the Down Arrow key value.
     * This is specific ONLY to IE11
     * where it does not prefix it with 'Arrow'.
     * @returns {String} The Down Arrow key value.
     */
    static get Down() {return keyCodes.DOWN;}

    /**
     * Gets the Down Arrow key value.
     * @returns {String} The Down Arrow key value.
     */
    static get DownArrow() {return keyCodes.ARROW_DOWN;}

    /**
     * Gets the End key value.
     * @returns {String} The End key value.
     */
    static get End() {return keyCodes.END;}

    /**
     * Gets the Enter key value.
     * @returns {String} The Enter key value.
     */
    static get Enter() {return keyCodes.ENTER;}

    /**
     * Gets the Esc key value.
     * This is specific ONLY to IE11
     * where it does not use 'Escape'.
     * @returns {String} The Esc key value.
     */
    static get Esc() {return keyCodes.ESC;}

    /**
     * Gets the Escape key value.
     * @returns {String} The Escape key value.
     */
    static get Escape() {return keyCodes.ESCAPE;}

    /**
     * Gets the Home key value.
     * @returns {String} The Home key value.
     */
    static get Home() {return keyCodes.HOME;}

    /**
     * Gets the Left Arrow key value.
     * This is specific ONLY to IE11
     * where it does not prefix it with 'Arrow'.
     * @returns {String} The Left Arrow key value.
     */
    static get Left() {return keyCodes.LEFT;}

    /**
     * Gets the Left Arrow key value.
     * @returns {String} The Left Arrow key value.
     */
    static get LeftArrow() {return keyCodes.ARROW_LEFT;}

    /**
     * Gets the Right Arrow key value.
     * This is specific ONLY to IE11
     * where it does not prefix it with 'Arrow'.
     * @returns {String} The Right Arrow key value.
     */
    static get Right() {return keyCodes.RIGHT;}

    /**
     * Gets the Right Arrow key value.
     * @returns {String} The Right Arrow key value.
     */
    static get RightArrow() {return keyCodes.ARROW_RIGHT;}

    /**
     * Gets the Space key value.
     * @returns {String} The Space key value.
     */
    static get Space() {return keyCodes.SPACE;}

    /**
     * Gets the Space key value. This is specific ONLY to IE11
     * where it returns 'Spacebar' instead of ' '.
     * @returns {String} The Space key value.
     */
    static get Spacebar() {return keyCodes.SPACEBAR;}

    /**
     * Gets the Tab key value.
     * @returns {String} The Tab key value.
     */
    static get Tab() {return keyCodes.TAB;}

    /**
     * Gets the Up Arrow key value.
     * This is specific ONLY to IE11
     * where it does not prefix it with 'Arrow'.
     * @returns {String} The Up Arrow key value.
     */
    static get Up() {return keyCodes.UP;}

    /**
     * Gets the Up Arrow key value.
     * @returns {String} The Up Arrow key value.
     */
    static get UpArrow() {return keyCodes.ARROW_UP;}
}
